/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Equipment } from '../models/Equipment';
import type { Tag } from '../models/Tag';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class MetadataService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * List equipment
     * Get all available equipment for exercise tagging
     * @returns any List of equipment
     * @throws ApiError
     */
    public getEquipment(): CancelablePromise<{
        equipment: Array<Equipment>;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/equipment',
        });
    }

    /**
     * List exercise tags
     * Get system tags and trainer's own tags for exercise tagging
     * @returns any List of tags
     * @throws ApiError
     */
    public getTags(): CancelablePromise<{
        tags: Array<Tag>;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/tags',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden — trainer role required`,
            },
        });
    }

}
